<template>
  <div class="login">
    <div class="masking" v-if="code" @click="closeMasking"></div>
    <!-- 登录 -->
    <div class="top">
      <div class="container" >
        <div class="logo">
          <img src="../assets/images/login_icon1.png" alt="">
        </div>
        <div class="title">
          <p class="big"  @click="toIndex">中小学教师网络法治教育培训项目</p>
          <!--<p class="small"  @click="toIndex">苏培计划（八五普法）”——中小学教师网络法治教育培训项目</p>-->
        </div>
        <!-- <div class="contact" @mouseover="showCode" @mouseleave="closeMasking">
          <span class="text">关注我们</span>
          <img src="../assets/images/wechat.png" alt="联系我们">
          <div class="code" v-if="code">
            <img class="code_bg" src="../assets/images/code_bg.png" alt="">
            <img class="qrcode" src="../assets/images/code.png" alt="">
          </div>
        </div> -->
        <!-- 直播二维码 -->
        <div class="code_box">
          <div class="code_box_item">
            <!-- <div class="item_l">
               <div>扫码进入直播 11月4日 15:00-17:00</div>
               <div style="margin-top: 0.08rem;">《未成年人学校保护规定》理解与适用（选修）</div>
             </div>
             <el-image class="item_img" :src="zhiboImg1" :preview-src-list="srcList"></el-image> -->
           </div>
           <div class="code_box_item">
             <!--<div class="item_l">
               <div>扫码进入直播 11月15日 14:00-16:00</div>
               <div style="margin-top: 0.08rem;">有效应对校园欺凌（选修）</div>
             </div>
             <el-image class="item_img" :src="zhiboImg2" :preview-src-list="srcList"></el-image>-->
           </div>
         </div>
       </div>
       <!-- <div style="position:absolute;font-size: 20px;margin-left: 80%;margin-top: 30px;color: red"><a href="http://qspfw.moe.gov.cn/html/gpjh2020/" target="_blank" style="color: red">2020年国培入口</a></div>-->
    </div>
    <div class="login_content">
      <div class="login_logo">
        <img src="../assets/images/login_bg.png" alt="">
      </div>
      <div class="login_box">
        <div class="list" style="margin-top: 0.4rem;">
          <img style="width: 0.26rem;height: 0.24rem;margin: 0.19rem 0 0 0.37rem;" src="../assets/images/login_account.png" alt="">
          <span></span>
          <input ref="accountIpt" type="text" placeholder="输入身份证号码/手机号" v-model="account">
        </div>
        <div class="list">
          <img style="width: 0.22rem;height: 0.26rem;margin: 0.17rem 0 0 0.41rem;" src="../assets/images/login_password.png" alt="">
          <span></span>
          <input type="password" placeholder="请输入密码" v-model="password">
        </div>
        <!-- <div class="drag" ref="dragDiv">
            <div class="drag_bg"></div>
            <div class="drag_text">{{confirmWords}}</div>
            <div ref="moveDiv" @mousedown="mousedownFn($event)" :class="{'handler_ok_bg':confirmSuccess}+' handler handler_bg'" style="position: absolute;top: 0px;left: 0px;"></div>
         </div> -->

        <div class="drag_container">
          <drag-verify
            style="border-radius: 0;"
            :width="scrollWidth"
            :height="scrollHeight"
            text="拖动滑块验证"
            success-text="验证通过"
            background="#e8e8e8"
            progress-bar-bg="#7ac23c"
            completed-bg="#7ac23c"
            handler-bg="#fff"
            text-size="16px"
            @passcallback="handleCallback"
          ></drag-verify>
        </div>
        <div class="method">
          <!-- <div class="checked">
            <input type="checkbox" id="checkbox" v-model="checked">
            <label for="checkbox" class="days">10天内免登陆</label>
          </div> -->
          <div class="toPassword" @click="toPassword">忘记密码？</div>
        </div>
        <div class="btnContainer" @click="login">
          <div>点击登录</div>
        </div>
        <!-- <p v-if="wrong" class="wrong">账号或密码错误</p> -->
      </div>
    </div>
  </div>
</template>

<script>
  import zhiboImg1 from "@/assets/images/zhibo1.png";
  import zhiboImg2 from "@/assets/images/zhibo2.png";
  import dragVerify from "vue-drag-verify";
  export default {
    components: {
      dragVerify,
    },
    data () {
      return {
        wrong:false,
        account:'',
        password:'',
        no_login:true,
        checked:false,
        zhiboImg1,
        zhiboImg2,
        code:false,
        beginClientX:0,   /*距离屏幕左端距离*/
        mouseMoveStata:false,  /*触发拖动状态 判断*/
        maxwidth:'',    /*拖动最大宽度，依据滑块宽度算出来的*/
        confirmWords:'拖动滑块验证', /*滑块文字*/
        confirmSuccess:false,   /*验证成功判断*/
        srcList:[zhiboImg1,zhiboImg2],
        scrollWidth: 400,
        scrollHeight: 33,
      }
    },
    mounted:function(){
      // this.maxwidth = this.$refs.dragDiv.clientWidth - this.$refs.moveDiv.clientWidth;
      setTimeout(() => {
        let _width = this.$refs.accountIpt.clientWidth
        this.scrollWidth = _width + _width / 2;
      }, 200);
      // document.getElementsByTagName('html')[0].addEventListener('mousemove',this.mouseMoveFn);
      // document.getElementsByTagName('html')[0].addEventListener('mouseup',this.moseUpFn)
    },
    methods:{
      toIndex(){
        // window.open("http://qspfw.moe.gov.cn/html/gpjh/");
      },
      closeMasking(){
        this.code = false;
      },
      showCode(){
        this.code = true;
      },
      toPassword(){
        this.$router.push("/Mobile");
      },
      login(){
        var _this = this;
        if(!this.mouseMoveStata){
          _this.$mResToast({
            type:'error',
            msg:'请先完成验证',
            duration:3000,
            isIcon:true,
          });
          return;
        }
        // this.$router.push('/Index');
        if(!this.account){
          _this.$mResToast({
            type:'error',
            msg:'请输入身份证号码或手机号',
            duration:3000,
            isIcon:true,
          });
          this.wrong = true;
          return false
        }
        if(!this.account || (!this.password)){
          _this.$mResToast({
            type:'error',
            msg:'请输入密码',
            duration:3000,
            isIcon:true,
          });
          this.wrong = true;
          return false
        }else{
          this.wrong = false;
        }
        var params = {
          loginInfo:this.account,
          password:this.password,
          captcha:'',
          uuid:'',
          source:_this.checked ? 1 : 0,
        }
        this.post('/trainee/login',params,(data)=>{
          if(data.status == 200){
            localStorage.setItem('token',data.data.access_token);
            localStorage.setItem('event',JSON.stringify(data.data.event));
            localStorage.setItem('config',JSON.stringify(data.data.config));
            if(data.data.config.isBeforeTest == 1){
              this.$router.push('./BeforeTest');
            }else {
              if (data.data.event.status == 1) {
                this.$router.push('./Course');
              } else if (data.data.event.status == 2) {
                this.$router.push('./Course');
              } else {
                this.$router.push('/Achieve');
              }
            }
          }else{
            _this.$mResToast({
              type:data.status == 200 ? 'success' : 'error',
              msg:data.msg,
              duration:3000,
              isIcon:true,
            });
          }
          console.log(data);
        })
      },
      handleCallback() {
        this.mouseMoveStata = true;
        this.confirmSuccess = true;
      },
      mousedownFn:function (e) {
        if(!this.confirmSuccess){
          e.preventDefault && e.preventDefault(); //阻止文字选中等 浏览器默认事件
          this.mouseMoveStata = true;
          this.beginClientX = e.clientX;
        }
      },  //mousedoen 事件
      // successFunction(){
      //   this.confirmSuccess = true
      //   this.confirmWords = '验证通过';
      //   if(window.addEventListener){
      //     document.getElementsByTagName('html')[0].removeEventListener('mousemove',this.mouseMoveFn);
      //     document.getElementsByTagName('html')[0].removeEventListener('mouseup',this.moseUpFn);
      //   }else {
      //     document.getElementsByTagName('html')[0].removeEventListener('mouseup',()=>{});
      //   }
      //   document.getElementsByClassName('drag_text')[0].style.color = '#fff'
      //   document.getElementsByClassName('handler')[0].style.left = this.maxwidth + 'px';
      //   document.getElementsByClassName('drag_bg')[0].style.width = this.maxwidth + 'px';
      // },    //验证成功函数
      // mouseMoveFn(e){
      //   if(this.mouseMoveStata){
      //     let width = e.clientX - this.beginClientX;
      //     if(width>0 && width<=this.maxwidth){
      //       document.getElementsByClassName('handler')[0].style.left = width + 'px';
      //       document.getElementsByClassName('drag_bg')[0].style.width = width + 'px';
      //     }else if(width>this.maxwidth){
      //       this.successFunction();
      //     }
      //   }
      // },     //mousemove事件
      // moseUpFn(e){
      //   this.mouseMoveStata = false;
      //   var width = e.clientX - this.beginClientX;
      //   if(width<this.maxwidth){
      //     document.getElementsByClassName('handler')[0].style.left = 0 + 'px';
      //     document.getElementsByClassName('drag_bg')[0].style.width = 0 + 'px';
      //   }
      // },      //mouseup事件



    }
  }
</script>

<style scoped>
  .login{
    width: 100%;
  }

  .masking{
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background-color: rgba(0,0,0,0.7);
    z-index: 20;
  }




  .drag{
    position: relative;
    background-color: #e8e8e8;
    width: 400px;
    height: 0.37rem;
    line-height: 0.37rem;
    text-align: center;
    margin-top: 0.24rem;
    margin: 0 auto 0.2rem auto;
  }
  .handler{
    width: 40px;
    height: 32px;
    border: 1px solid #ccc;
    cursor: move;
  }
  .handler_bg{
    background: #fff url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAA3hpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNS1jMDIxIDc5LjE1NTc3MiwgMjAxNC8wMS8xMy0xOTo0NDowMCAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wTU09Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9tbS8iIHhtbG5zOnN0UmVmPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvc1R5cGUvUmVzb3VyY2VSZWYjIiB4bWxuczp4bXA9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC8iIHhtcE1NOk9yaWdpbmFsRG9jdW1lbnRJRD0ieG1wLmRpZDo0ZDhlNWY5My05NmI0LTRlNWQtOGFjYi03ZTY4OGYyMTU2ZTYiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6NTEyNTVEMURGMkVFMTFFNEI5NDBCMjQ2M0ExMDQ1OUYiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6NTEyNTVEMUNGMkVFMTFFNEI5NDBCMjQ2M0ExMDQ1OUYiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIDIwMTQgKE1hY2ludG9zaCkiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDo2MTc5NzNmZS02OTQxLTQyOTYtYTIwNi02NDI2YTNkOWU5YmUiIHN0UmVmOmRvY3VtZW50SUQ9InhtcC5kaWQ6NGQ4ZTVmOTMtOTZiNC00ZTVkLThhY2ItN2U2ODhmMjE1NmU2Ii8+IDwvcmRmOkRlc2NyaXB0aW9uPiA8L3JkZjpSREY+IDwveDp4bXBtZXRhPiA8P3hwYWNrZXQgZW5kPSJyIj8+YiRG4AAAALFJREFUeNpi/P//PwMlgImBQkA9A+bOnfsIiBOxKcInh+yCaCDuByoswaIOpxwjciACFegBqZ1AvBSIS5OTk/8TkmNEjwWgQiUgtQuIjwAxUF3yX3xyGIEIFLwHpKyAWB+I1xGSwxULIGf9A7mQkBwTlhBXAFLHgPgqEAcTkmNCU6AL9d8WII4HOvk3ITkWJAXWUMlOoGQHmsE45ViQ2KuBuASoYC4Wf+OUYxz6mQkgwAAN9mIrUReCXgAAAABJRU5ErkJggg==") no-repeat center;
  }
  .handler_ok_bg{
    background: #fff url("../assets/images/mobile_check.png") no-repeat center;
  }
  .drag_bg{
    background-color: #7ac23c;
    height: 0.37rem;
    width: 0px;
  }
  .drag_text{
    font-size: 0.21rem;
    color: #fff;
    position: absolute;
    top: 0px;
    width: 100%;
    text-align: center;
    -moz-user-select: none;
    -webkit-user-select: none;
    user-select: none;
    -o-user-select:none;
    -ms-user-select:none;
  }





  .top{
    width: 100%;
    margin: 0 auto;
  }

  .top .container{
    width: 15rem;
    max-width: 100%;
    height: 1rem;
    margin: 0 auto;
    display: flex;
    align-items: center;
  }


  .logo{
    width: 0.57rem;
    height: 0.58rem;
    /* float: left; */
    /* margin: 0.22rem 0.06rem 0 0; */
    margin-right:0.06rem;
    display: flex;
    align-items: center;
  }
  .logo img{
    width: 100%;
    height: 100%;
    /* float: left; */
  }
  .title{
    /* float: left; */
    /* width: 10rem; */
  }
  .big{
    /* float: left; */
    width: 100%;
    font-size: 0.22rem;
    color: #de0000;
    height: 0.22rem;
    line-height: 0.22rem;
    /* margin-top:0.3rem; */
  }
  .small{
    /* float: left; */
    width: 100%;
    font-size: 0.18rem;
    color: #989898;
    height: 0.18rem;
    line-height: 0.18rem;
    margin-top: 0.1rem;
  }
  .code_box {
    float: right;
    display: flex;
  }
  .code_box .code_box_item {
    display: flex;
    align-items: center;
    margin-left: 0.6rem;
  }
  .code_box .code_box_item .item_l {
    font-size: 0.16rem;
    color: #100202;
    text-align: right;
  }
  .code_box .code_box_item .item_img {
    width: 0.67rem;
    height: 0.58rem;
    margin-left: 0.1rem;
  }
  .contact{
    float: right;
    width: 2.1rem;
    height: 0.56rem;
    margin: 0.34rem 0.07rem 0 0;
    cursor: pointer;
    position: relative;
    z-index: 999;
    cursor: pointer;
  }
  .contact span{
    font-size: 0.25rem;
    color: #989898;
    line-height: 0.56rem;
    float: left;
  }
  .contact img{
    width: 0.56rem;
    height: 0.56rem;
    margin-left: 0.3rem;
    float: left;
  }
  .code{
    width: 2.11rem;
    height: 2.13rem;
    position: absolute;
    top: 0.6rem;
    right: 0.2rem;
    z-index: 30;
  }
  .code .code_bg{
    float: left;
    width: 2.11rem;
    height: 2.13rem;
    margin: 0;
  }
  .code .qrcode{
    width: 1.77rem;
    height: 1.69rem;
    position: absolute;
    left: 50%;
    top: 0.31rem;
    transform: translate(-50%,0);
    margin: 0;
  }

  .login_logo{
    /* width: 15rem; */
    width: 100%;
    height: 7.45rem;
    position: relative;
  }
  .login_logo img{
    width: 100%;
    height: 100%;
    position: absolute;
  }
  .login_content{
    /* width: 15rem; */
    width: 100%;
    /* height: 6.9rem; */
    margin: 0 auto;
    position: relative;
  }
  .login_box{
    position: absolute;
    right: 2.37rem;
    top: 1.93rem;

    width: 5.25rem;
    min-height: 4.17rem;
    background-color: #ffffff;
    box-shadow: 0.03rem 0.04rem 0.32rem 0rem
    rgba(255, 92, 92, 0.4);
    border-radius: 0.2rem;

  }
  .login_box .list{
    width: 4.51rem;
    height: 0.64rem;
    border-radius: 0.32rem;
    border: 0.01rem solid #c8c8c8;
    margin: 0 auto 0.32rem auto;
    position: relative;
  }
  .login_box .list img{
    float: left;
  }
  .login_box .list span{
    width: 0.02rem;
    height: 0.21rem;
    background-color: #b8b8b8;
    position: absolute;
    top: 50%;
    left: 0.83rem;
    transform: translate(0,-50%);
  }
  .login_box .list input{
    width: 3rem;
    height: 0.4rem;
    float: left;
    border: none;
    outline: none;
    font-size: 0.18rem;
    color: #c1c1c1;
    margin-top: 0.12rem;
    margin-left: 0.56rem;
  }
  .login_box .list p{
    font-size: 0.21rem;
    color: #ff4200;
  }
  .login_box .method{
    width: 4.24rem;
    height: 0.2rem;
    line-height: 0.2rem;
    margin: 0 auto;
  }
  .login_box .method .checked{
    float: left;
    cursor:pointer;
  }
  .login_box .method .checked input{
    float: left;
    margin-right: 0.1rem;
    margin-top: 0.04rem;
  }
  .login_box .method .checked .days{
    float: right;
    font-size: 0.17rem;
    color: #8b8b8b;
  }
  .login_box .method .toPassword{
    float: right;
    font-size: 0.16rem;
    color: #fe4341;
    cursor:pointer;
  }
  .btnContainer{
    font-size: 0.25rem;
    color: #fff;
    text-align: center;
    line-height: 0.64rem;
    margin: 0.18rem auto 0.09rem auto;


    width: 4.51rem;
    height: 0.64rem;
    background-color: #de0000;
    border-radius: 0.32rem;


    cursor:pointer;
  }
  .wrong{
    font-size: 0.21rem;
    color: #ff4200;
    float: right;
    margin-right: 0.62rem;
  }
  .drag_container {
    display: flex;
    justify-content: center;
    margin: 0 auto 0.2rem;
  }
  .drag_container  >>>.dv_handler {
    width: 40px !important;
    height: 33px !important;
    border: 1px solid #ccc !important;
    cursor: move;
    border-radius: 0 !important;
    background: #fff url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAA3hpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNS1jMDIxIDc5LjE1NTc3MiwgMjAxNC8wMS8xMy0xOTo0NDowMCAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wTU09Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9tbS8iIHhtbG5zOnN0UmVmPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvc1R5cGUvUmVzb3VyY2VSZWYjIiB4bWxuczp4bXA9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC8iIHhtcE1NOk9yaWdpbmFsRG9jdW1lbnRJRD0ieG1wLmRpZDo0ZDhlNWY5My05NmI0LTRlNWQtOGFjYi03ZTY4OGYyMTU2ZTYiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6NTEyNTVEMURGMkVFMTFFNEI5NDBCMjQ2M0ExMDQ1OUYiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6NTEyNTVEMUNGMkVFMTFFNEI5NDBCMjQ2M0ExMDQ1OUYiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIDIwMTQgKE1hY2ludG9zaCkiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDo2MTc5NzNmZS02OTQxLTQyOTYtYTIwNi02NDI2YTNkOWU5YmUiIHN0UmVmOmRvY3VtZW50SUQ9InhtcC5kaWQ6NGQ4ZTVmOTMtOTZiNC00ZTVkLThhY2ItN2U2ODhmMjE1NmU2Ii8+IDwvcmRmOkRlc2NyaXB0aW9uPiA8L3JkZjpSREY+IDwveDp4bXBtZXRhPiA8P3hwYWNrZXQgZW5kPSJyIj8+YiRG4AAAALFJREFUeNpi/P//PwMlgImBQkA9A+bOnfsIiBOxKcInh+yCaCDuByoswaIOpxwjciACFegBqZ1AvBSIS5OTk/8TkmNEjwWgQiUgtQuIjwAxUF3yX3xyGIEIFLwHpKyAWB+I1xGSwxULIGf9A7mQkBwTlhBXAFLHgPgqEAcTkmNCU6AL9d8WII4HOvk3ITkWJAXWUMlOoGQHmsE45ViQ2KuBuASoYC4Wf+OUYxz6mQkgwAAN9mIrUReCXgAAAABJRU5ErkJggg==") no-repeat center !important;

  }

  .drag_container  >>>.drag_verify {
    border-radius: 0 !important;
  }
  .drag_container  >>>.dv_progress_bar {
    border-radius: 0 !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/Login.vue